import { Snackbar } from "@octopusdeploy/design-system-components";
import React from "react";
export default function TaskQueueUpdatedSnackbar({ open, text, onClose }: {
    open: boolean;
    text: string;
    onClose: () => void;
}) {
    return <Snackbar open={open} content={text} autoHideDuration={3500} onClose={onClose} textAlign={"center"}/>;
}
